module.exports = __webpack_public_path__ + "static/media/Gruppenbestellung.22514421.png";